<template>
  <div class="account-component">
    <VeeForm ref="form" class="account-form" @submit="onSaveQuit">
      <section>
        <IconLabel heavy no-padding :label="$t('ETAB.PAGES.PROFIL.@ACCOUNT_INFORMATION')" icon="icon-f-settings" />
        <Field
          v-slot="{ errors, field, value }"
          v-model="internalAccount[IAccount.lastname]"
          :name="$filters.formLabelValidation($t('ETAB.FORMS.LABELS.@LASTNAME'))"
          :rules="{ required: true }"
        >
          <QInput
            v-bind="field"
            :model-value="value"
            :name="IAccount.lastname"
            type="text"
            :label="$t('ETAB.FORMS.LABELS.@LASTNAME')"
            :error="errors.length > 0"
            :error-message="errors[0]"
          />
        </Field>

        <Field
          v-slot="{ errors, field, value }"
          v-model="internalAccount[IAccount.firstname]"
          :name="$filters.formLabelValidation($t('ETAB.FORMS.LABELS.@FIRSTNAME'))"
          :rules="{ required: true }"
        >
          <QInput
            v-bind="field"
            :model-value="value"
            :name="IAccount.firstname"
            type="text"
            :label="$t('ETAB.FORMS.LABELS.@FIRSTNAME')"
            :error="errors.length > 0"
            :error-message="errors[0]"
          />
        </Field>

        <Field
          v-slot="{ errors, field, value }"
          v-model="internalAccount[IAccount.phone]"
          :name="$filters.formLabelValidation($t('ETAB.FORMS.LABELS.@MOBILE_NUMBER'))"
          :rules="{ required: true, regex: PHONE_REGEX }"
        >
          <QInput
            v-bind="field"
            :model-value="value"
            :name="IAccount.phone"
            type="tel"
            :label="$t('ETAB.FORMS.LABELS.@MOBILE_NUMBER')"
            :error="errors.length > 0"
            :error-message="errors[0]"
          />
        </Field>

        <div class="read-only-input">
          <label>{{ $t("ETAB.FORMS.LABELS.@EMAIL") }}</label>
          <p>{{ internalAccount[IAccount.email] }}</p>
        </div>
      </section>

      <QFooter class="bg-transparent footer-padding">
        <div>
          <QBtn
            type="submit"
            color="secondary"
            class="full-width btn-navigation semi-transparent-bottom-shadow"
            :label="$t('ETAB.BUTTONS.@SAVE_QUIT')"
            no-caps
          />
        </div>
      </QFooter>
    </VeeForm>
  </div>
</template>

<script>
  import { Form as VeeForm, Field } from "vee-validate";
  import { PHONE_REGEX } from "@core/helpers";
  import { AccountModel, IAccount } from "@core/models";

  export default {
    components: {
      VeeForm,
      Field,
    },
    props: {
      account: { type: Object, default: () => ({}) },
    },
    emits: ["onSaveQuit"],
    data() {
      return {
        internalAccount: new AccountModel(),
      };
    },
    created() {
      this.IAccount = IAccount;
      this.PHONE_REGEX = PHONE_REGEX;
    },
    mounted() {
      this.internalAccount = new AccountModel(this.account);
    },
    methods: {
      async onSaveQuit() {
        const valid = await this.$refs.form.validate();
        if (valid) {
          this.$emit("onSaveQuit", { account: this.internalAccount });
        }
      },
    },
  };
</script>

<style lang="scss">
  .account-component {
    $space_for_validation: 16px;

    > form > section {
      padding: 15px;

      .q-input {
        margin-top: $space_for_validation;
      }

      .read-only-input {
        margin-top: $space_for_validation;
        label {
          font-weight: bold;
        }
      }
    }
  }
</style>
